module.exports = __webpack_public_path__ + "img/ama_long.8e003e50.png";